import { ConfirmProvider, EditTabsPattern } from '@/components'
import { useComponentProvider } from '@/components/ViewComponentModal/ViewComponentProvider'

import { ConfigData, History, Questions, Settings } from './tabs'

const tabs = [
  {
    component: <Settings />,
    name: 'settings',
  },
  { component: <Questions />, name: 'questions' },
  { component: <History />, name: 'version' },
  { component: <ConfigData />, name: 'config' },
]
export const SemanticSearch = () => {
  const { componentID, useUrl } = useComponentProvider()

  return (
    <ConfirmProvider>
      <EditTabsPattern
        defaultTab="settings"
        showTabs={!!componentID}
        tabs={tabs}
        urlParams={useUrl}
      />
    </ConfirmProvider>
  )
}
